import { get } from "./api";

export const getEvents = () => {
  return get("/api/v1/events");
};

export const getEvent = (slug: string) => {
  return get(`/api/v1/events/${ slug }`);
}